import { Box, Button, Grid } from "@mui/material";
import { IFeesTabViewProps, TFee } from "../../interfaces/configuration";
import { MEDIUM } from "../../utils/constants";
import SearchFees from "../fees/SearchFees";
import GenericAlert from "../GenericAlert";
import Loader from "../Loader";
import FeeModal from "../modals/FeeModal";
import ListFeesContainer from "../tables/ListFeesContainer";
import { IAlert } from "../../interfaces/alert";

const FeesTabView = ({
  handleGetFees,
  handleCreateFeeRule,
  loading,
  alert,
  fees,
  dispatch,
  handlePageChange,
  page,
  count,
  openModal,
  selectedAction,
  selectedFee,
}: IFeesTabViewProps) => (
  <Grid container flexDirection="column" className="m-t-30">
    <Grid item container md={5} lg={4} spacing={2}>
      <Grid item xs={8}>
        <SearchFees {...{ handleGetFees }} />
      </Grid>
      <Grid item xs={4}>
        <Button fullWidth variant="contained" onClick={handleCreateFeeRule}>
          Añadir regla
        </Button>
      </Grid>
    </Grid>

    {!loading && (
      <Grid item xs={12}>
        {alert.showAlert && (
          <Box width="100%" mt={3}>
            <GenericAlert alert={alert} />
          </Box>
        )}
        {fees.length > 0 && (
          <ListFeesContainer
            {...{
              fees,
              setFees: (updatedFees: TFee[]) =>
                dispatch({ type: "setFees", value: updatedFees }),
              setSelectedFee: (fee: TFee) =>
                dispatch({ type: "setSelectedFee", value: fee }),
              setAlert: (newAlert: IAlert) =>
                dispatch({ type: "setAlert", value: newAlert }),
              handleGetFees,
              handlePageChange,
              page,
              count,
            }}
          />
        )}
      </Grid>
    )}

    <FeeModal
      open={openModal}
      setOpen={(open: boolean) =>
        dispatch({ type: "setOpenModal", value: open })
      }
      action={selectedAction}
      selectedFee={selectedFee}
      setSelectedFee={(fee: TFee | null) =>
        dispatch({ type: "setSelectedFee", value: fee as TFee })
      }
      handleGetFees={handleGetFees}
    />

    {loading && <Loader size={MEDIUM} />}
  </Grid>
);

export default FeesTabView;
